"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SourceListAudioFileItemBody = require("./SourceListAudioFileItemBody.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SourceListAudioFileItemBody = function SourceListAudioFileItemBody(_ref) {
  var value = _ref.value;
  var audioRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
    volume = _useState2[0];
  (0, _react.useEffect)(function () {
    audioRef.current.volume = volume / 100;
    audioRef.current.currentTime = 0;
  });
  return /*#__PURE__*/_react["default"].createElement(_SourceListAudioFileItemBody.AudioPlayer, null, /*#__PURE__*/_react["default"].createElement("audio", {
    ref: audioRef,
    src: value
  }, "Your browser does not support the audio file"));
};
SourceListAudioFileItemBody.propTypes = {
  value: _propTypes["default"].string,
  hidden: _propTypes["default"].bool,
  live: _propTypes["default"].bool
};
var _default = exports["default"] = SourceListAudioFileItemBody;